import React from 'react';
import {OrbitComponent} from "../../../../../../base-components/orbit-component/orbit-component";
import {FooterContainerBox} from "./boxes/footer-container.box";
import {NetPositionComponent} from "../../../../../common/parts/net-position/net-position.component";
import {GameDurationComponent} from "../../../../../common/parts/game-duration/game-duration.component";
import {
    IGameContextViewModel
} from "../../../../../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {observer} from "mobx-react";
import {
    BlankHorizontalSeparatorBox
} from "../../../../../../../basic-components/blank-separator/blank-horizontal-separator.box";
import {GameFooterBarComponent} from "../../../../game-footer-bar.component";
import {JackpotBarMagicBallComponent} from '../../../../../jackpot-bar-magic-ball/jackpot-bar-magic-ball.component';

interface OntarioGamePlayPcFooterBarComponentProps {
    gameContext: IGameContextViewModel;
}

export const OntarioGamePlayPcFooterBarComponent = observer(
    class OntarioGamePlayPcFooterBarComponent extends OrbitComponent<OntarioGamePlayPcFooterBarComponentProps> {
        
        private shouldRenderIGCMagic8Ball = () => {
            // If jackpot bet is enabled then the magic ball button will be rendered in game-jackpot-bar.component
            if (this.services.jackpotBet.isEnabled && this.props.gameContext.gameInfo.hasJackpotBet) {
                return false;
            }
            return this.services.magic8ball.shouldRenderBall;
        };

        private _renderBottomSection = () => {
            if (!this.shouldRenderIGCMagic8Ball()) {
                return null;
            }
            return <FooterContainerBox>
                <div style={{padding: "0.5rem"}}>
                    <JackpotBarMagicBallComponent />
                </div>
            </FooterContainerBox>
        }

        private _renderTopSection = () => {
            return (
                <FooterContainerBox>
                    <NetPositionComponent gameContext={this.props.gameContext}/>
                    <BlankHorizontalSeparatorBox/>
                    <GameDurationComponent gameContext={this.props.gameContext}/>
                </FooterContainerBox>
            );
        }
        render() {
            return (
                <GameFooterBarComponent gameContext={this.props.gameContext} renderTopSection={this._renderTopSection} renderBottomSection={this._renderBottomSection}/>
            )
        }
    }
);